export enum MergeMethodEnum {
  Copy,
  Merge,
  Ignore,
}
